import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  salesmanData: {},
  salesmanStatus: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'salesman',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSalesmanData: (state, action) => {
      state.salesmanData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postSalesData: (state, action) => {
      state.salesmanStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetStatus: (state) => {
      state.salesmanStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {fetchStart, fetchError, fetchSalesmanData, postSalesmanData, resetMsg, resetStatus} =
  slice.actions;
export const fetchSalesman = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      //   httpPost("lookup/find/all/lookup", {
      //   }),
      httpGet(`${CLIENT_MAINTENANCE}/find/salesmanidlist/${clientNumber}`),
    ])
      .then((data) => {
        const interestData = data && data[0] ? data[0] : null;
        if (interestData?.status && interestData.status === 200) {
          dispatch(fetchSalesmanData(interestData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postSalesman = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/salesmanidlist`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSalesmanData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetSalesmanStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
